import {
  TitleProps as MantineTitleProps,
  Title as MantineTitle,
} from '@mantine/core';

export type TitleProps = MantineTitleProps;

export const Title = MantineTitle;

Title.displayName = 'Title';
